import {
    GET_ASSET_SUB_TYPE,
    SET_ASSET_SUB_TYPE
} from "./AssetSubTypeType"

const getAssetSubType = (assetTypeId: number) => ({
    type: GET_ASSET_SUB_TYPE,
    assetTypeId : assetTypeId
});

const setAssetSubType = (assetSubType: any) => ({
    type: SET_ASSET_SUB_TYPE,
    assetSubType: assetSubType
});

export {
    getAssetSubType,
    setAssetSubType
}
